import React from "react";
import { Markup } from 'interweave';
import Styles from "./presentation.module.scss";
import { Container, Col, Row } from 'reactstrap';
import GeneralService from "services/generalService";
import Picture from "components/common/picture/picture";

interface IPresentationProps {
}

interface IPresentationState {
    contentTop: string;
    contentLeft: string;
    contentRight: string;
    contentBottom: string;
    pictureLeft: string;
    pictureRight: string;
}

class Presentation extends React.Component<IPresentationProps, IPresentationState>{

    /**
     *
     */
    constructor(props: IPresentationProps) {
        super(props);

        this.state = { contentTop: '', contentLeft: '', contentRight: '', contentBottom: '', pictureLeft: '', pictureRight:'' } as IPresentationState
    }

    componentDidMount() {
        GeneralService.GetGeneral().then(gen => {
            this.setState({ contentTop: gen.PresentationHaut, contentLeft: gen.PresentationGauche, contentRight: gen.PresentationDroite, contentBottom: gen.PresentationBas, pictureLeft: gen.PresentationPhotoGauche, pictureRight: gen.PresentationPhotoDroite })
        })
    }

    render() {
        return (
            <div className={Styles.Presentation}>
                <Container>
                    <Markup content={this.state.contentTop} />
                    <Row>
                        <Col xs="12" md="6" className="d-flex flex-column align-items-center" >
                            <Picture className={Styles.avatar} RenditionID={3} PictureUrl={encodeURI(this.state.pictureLeft)} />
                            <div dangerouslySetInnerHTML={{ __html: this.state.contentLeft }}>
                                
                            </div>
                        </Col>
                        <Col xs="12" md="6" className="d-flex flex-column align-items-center">
                            <Picture className={Styles.avatar} RenditionID={3} PictureUrl={encodeURI(this.state.pictureRight)} />
                        <div dangerouslySetInnerHTML={{ __html: this.state.contentRight }}>
                            
                        </div>
                        </Col>
                    </Row>
                    <Markup content={this.state.contentBottom} />
                </Container>
            </div>
        );
    }
}

export default Presentation;